let paymentSessionVersion = 0

export const getPaymentSessionVersion = () => paymentSessionVersion

export const bumpPaymentSession = () => {
  paymentSessionVersion += 1
}
